export default "__VITE_ASSET__Bh7pWWjB__"